<template>
  <donut-chart-card
    :size="size"
    title="산업재해 발생 현황"
    :value="data"
    :init-total="total"
    :unit="unit"
    :isMoveWrite="isMoveWrite"
    :is-move-detail="!!projectId"
    :orientation="orientation"
    @detail="onClickDetail"
    @write="onClickWrite"
  ></donut-chart-card>
</template>

<script>
import DonutChartCard from '@/components/DonutChartCard'
import CircleGraphUtil from "@/util/CircleGraphUtil";
export default {
  name: "DonutChart312",
  components: { DonutChartCard },
  props: {
    dataType: "detail" | "field" | "company" | "project",
    size: String,
    orientation: {
      type: "landscape" | "portrait",
      default: () => "portrait"
    },
    unit: {
      type: String,
      default: () => "건"
    },
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    isMoveWrite() {
      // if (Number(`${this.projectId}`) === 1) return false
      // else return true
      return true;
    },
  },
  watch: {
    dataType() {
      this.loadGraph();
    },
  },
  data() {
    return {
      graphId: 312,
      boardId: 117,
      summaryKey: ["중대재해발생_재해형태", "count"],
      data: [{ label: "label", value: 0 }],
      total: "0",
    };
  },
  async mounted() {
    await this.loadGraph();
  },
  methods: {
    async loadGraph() {
      const fromDate = `${new Date().getFullYear()}-01-01`;
      const toDate = `${new Date().getFullYear()}-12-31`;
      const conditions = [
        { key: 'body.stdInfo.date', operator: '>=', value: fromDate },
        { key: 'body.stdInfo.date', operator: '<=', value: toDate },
      ];

      const params = {
        projectId: this.projectId,
        boardId: 117,
        page: 1,
        perPage: 10000,
        conditions,
        withMeta: true,
        metaKeys: [
          'body.inputD_5', // 재해형태
          'body.stdInfo.date' // 일자
        ],
        onlyMeta: true,
        withoutRelation: true,
        forDashboard: true,
      };

      const response = await this.$store.dispatch('board/LOAD_POST_LIST', params);
      const postList = response.data || [];

      const data = [/* {label : '넘어짐', value : 0}, */];
      let sum = 0;
      for (const post of postList) {
        const postContents = post.postContents || {};
        const 재해형태 = (postContents.body && postContents.body.inputD_5) || '기타';

        if (!data.some(item => item.label === 재해형태)) {
          data.push({ label: 재해형태, value: 1 });
        } else {
          const index = data.findIndex(item => item.label === 재해형태);
          if (index !== -1) {
            data[index].value += 1;
          }
        }
        sum += 1;
      }

      this.data = data;
      this.total = `${sum}`;
    },
    onClickDetail() {
      const projectId = this.$route.params.proj_id;
      const graphId = this.graphId;
      if (projectId) {
        this.$router.push(`/project/${projectId}/graph-detail/${graphId}`);
      } else {
        this.$router.push(`/graph-detail/${graphId}`);
      }
    },
    onClickWrite() {
      const proj_id = this.$route.params.proj_id;
      const boardId = `${this.boardId}`;
      this.$router.push({ name: "write|tab", params: { pageType: "write", proj_id, boardId } });
    },
  },
};
</script>

<style scoped></style>
